/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.25",
    versionName: "0.2.0-nightly.2025.10.25",
    versionChannel: "nightly",
    buildDate: "2025-10-25T00:07:42.750Z",
    commitHash: "abef7ddae96a95dde3a3288026f2343ff13ed0e0",
};
